module.exports = __webpack_public_path__ + "img/double-down-arrow.11e73d56.svg";